module.exports = __webpack_public_path__ + "img/kanneh.54e91dc6.png";